export const ProjectData = [
    {
        id:1,
        title:"My Ecommerce App",
        about:"Here I have build an ecommerce application with the help of react,nextjs,sanity and many more. Here I have made a fully functionality ecommerce website, where user can buy his product just like the original sites.",
        tags: ["React","NextJs", "Sanity", "Sanity-io", "Stripe", "Stripe Api"],
        demo: "https://my-ecommerce-indol.vercel.app/"  ,
        github: "https://github.com/AbhishekKasera7696/MyEcommerce",
        image: "https://i.ibb.co/f0cqHJx/Screenshot-19.png"
    },

    
    
    {
        id:2,
        title:"Video Chat App",
        about: "Features : Users can do video calls by sharing their codes and have fun with each other this app also ask you to give permission for microphone and video",
        tags: ["React_JS", "Material_UI" , "WebRTC", "NodeJS", "Socket.io", "ExpressJS"],
        demo: "https://abhishekmychatapp.netlify.app/"  ,
        github: "https://github.com/AbhishekKasera7696/video_chat_app",
        image: "https://i.ibb.co/4NVJgxT/Screen-Shot-2020-03-25-at-11-14-30-AM.jpg"
    },


    {
        id: 3,
        title:"Youtube",
        about: " Features: Users can search any videos in searchbar,Can play any videos on clicking thumbnails.Developed the Youtube.com, using Youtube api.",
        tags: ["HTML" , "Css", "Javscript"],
        demo: "https://youtubeabhiclone.netlify.app/",
        github: "https://github.com/AbhishekKasera7696/Youtube",
        image : "https://i.ibb.co/hyPJDKJ/Capture-youtube.png"
    },

   
    {
        id: 4,
        title:"Fitmeals",
        about: "Fitmeals.co.in is an online food delivering website, which deals with wholesome & nourishing foods that make people feel the best version of themself. Areas of responsibility: Developed the entire homepage of the Fitmeals.co.in. A collaborative project, built in 5 days by a team of 4 developers.",
        tags: ["HTML" , "Css", "Javscript"],
        demo: "https://featmealclone.netlify.app/",
        github: "https://github.com/AbhishekKasera7696/FitMeal",
        image : "https://i.ibb.co/qs7HYFM/Capture-fitmeals.png"
    },

    {
        id:5,
        title:"Tic Tac Toe",
        about: "Tic Tac Toe game we play this game many a time, here I have build this game with the help of HTML,CSS & Javscript, where two players can play and get the result of win,loss & tie",
        tags: ["HTML","Css", "Javascript"],
        demo: "https://ticmytactoe.netlify.app/"  ,
        github: "https://github.com/AbhishekKasera7696/tictactoe",
        image: "https://i.ibb.co/YZNqYMk/tic-tac-toe.png"
    },

    {
        id:6,
        title:"My Google Search Engine Clone",
        about: "Here I have build a functional google clone app ,here you can search whatever you want and can get your desirable result like google. ",
        tags: ["ReactJS","Context API", "Material-UI", "React Router", "Google Search API"],
        demo: "https://mygooglesearchengine.netlify.app/"  ,
        github: "https://github.com/AbhishekKasera7696/MyGoogleSearchEngineClone",
        image: "https://i.ibb.co/dgtct53/Google-Clone.png"
    }

    


]


